// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-images {\n  display: flex;\n  justify-content: space-between;\n}\n\n.footer-img {\n  width: 100%;\n}\n\n.footer {\n  text-align: center;\n  font-style: italic;\n  background-color: #f5f5f5;\n}\n\n@media (max-width: 992px) {\n  .footer-img {\n    width: 75%;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
